import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React, { useEffect } from "react";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import HttpService from "../../../hooks/Https-services";
import { APIRoutes } from "../../../utils/constants";
import { toast } from "react-toastify";
const LikeDisLike = ({ videoStats, LikeDisLikeFun }: any) => {
  const [alignment, setAlignment] = React.useState<string | null>("");
  const [loading, setLoading] = React.useState(false);
  const handleAlignment = async (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    setLoading(true);
    await LikeDisLikeFun(newAlignment);
    setLoading(false);

    setAlignment(newAlignment);
  };

  useEffect(() => {
    if (videoStats?.Reaction === 1 || videoStats?.Reaction === 2) {
      setAlignment(videoStats?.Reaction.toString());
    } else {
      setAlignment("0");
    }
  }, [videoStats]);

  return (
    <Box>
      <ToggleButtonGroup
        size="small"
        value={alignment}
        exclusive
        disabled={loading}
        onChange={handleAlignment}
        aria-label="text alignment"
        color="primary"
        sx={{
          ".MuiToggleButtonGroup-grouped:not(:last-of-type)": {
            borderTopLeftRadius: "50px",
            borderBottomLeftRadius: "50px",
          },
          ".MuiToggleButtonGroup-grouped:not(:first-of-type)": {
            borderTopRightRadius: "50px",
            borderBottomRightRadius: "50px",
          },
          ".MuiToggleButtonGroup-grouped": {
            py: "5px",
          },
        }}
      >
        <ToggleButton
          value="1"
          sx={{ whiteSpace: "nowrap" }}
          aria-label="left aligned"
        >
          <ThumbUpOffAltIcon />{" "}
          {videoStats?.LikesCount > 0 && videoStats?.LikesCount} Likes
        </ToggleButton>
        <ToggleButton
          value="2"
          sx={{ whiteSpace: "nowrap" }}
          aria-label="centered"
        >
          <ThumbDownOffAltIcon />
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
};
export default LikeDisLike;
